import React from 'react';
import { useSelector } from 'react-redux';


const createSingleFreeTextView = (freeText) => {
    return(
    <div key={freeText.id} className='free-text-item'>
        <div className='free-text'>
            <div className='text' style={{fontSize: `${freeText.size}vh`}}>
                {freeText.content}
            </div>
        </div>
    </div>
    )
}


const FreeText = () => {
    var freeTextState = useSelector((state) => state.freeTextState);
    var texts = freeTextState.text;
    if(texts != null){
        return texts.map(freeText => createSingleFreeTextView(freeText));
    }
    return null;
}

export default FreeText;